import { useState } from 'react'
import { useSubscriptionStatus } from '@/hooks/api'
import { subscriptionService } from '@/services/api'

export function useAppLayout() {
  const { data: subscription } = useSubscriptionStatus()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const isPastDue = subscription?.status === 'PAST_DUE'

  const handleUpdatePayment = async () => {
    setIsRedirecting(true)
    try {
      const { url } = await subscriptionService.createBillingPortal(window.location.href)
      window.location.href = url
    } catch {
      setIsRedirecting(false)
    }
  }

  return { isPastDue, isRedirecting, handleUpdatePayment }
}
